import { renderToString } from 'react-dom/server';
import { faqContent } from '../faq/flatbed';

var FAQSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [],
};

FAQSchema['mainEntity'] = faqContent.map((item, key) => {
  return {
    '@type': 'Question',
    name: item.title,
    acceptedAnswer: {
      '@type': 'Answer',
      text: renderToString(item.description),
    },
  };
});

export const FAQ = FAQSchema;
